// extracted by mini-css-extract-plugin
module.exports = {"root":"ListOripaCard_root__RuERi","noData":"ListOripaCard_noData__2Qws4","pagination":"ListOripaCard_pagination__3xPc0","rotate":"ListOripaCard_rotate__3qp5t"};